import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';

import { uiActions } from '../../actions';
import useDispatch from '../../hooks/useDispatch';
import useSelector from '../../hooks/useSelector';

interface TutorialQuestionMarkProps {
  tutorialId: number;
  alwaysVisible?: boolean;
}

const TutorialQuestionMark: React.FC<TutorialQuestionMarkProps> = ({
  tutorialId,
  alwaysVisible,
}) => {
  const dispatch = useDispatch();

  const { showQuestionMarks } = useSelector(state => state.ui.floatTutorial);

  if (!showQuestionMarks && !alwaysVisible) return null;

  return (
    <FaQuestionCircle
      style={{ cursor: 'pointer' }}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(uiActions.floatTutorial.hideQuestionMarks());
        dispatch(uiActions.floatTutorial.showTutorial(tutorialId));
      }}
    />
  );
};

export default TutorialQuestionMark;
